import React from 'react';

interface Props {
  id: string;
}

export const PrimisAMP: React.FC<Props> = ({ id }) => {
  return (
    <div
      dangerouslySetInnerHTML={{
        __html: `
        <amp-video-iframe
          src="https://live.primis-amp.tech/content/video/amp/videoIframe.php?s=${id}"
          width="16"
          height="9"
          layout="responsive"
          dock="#primis-dock-slot"
          style="overflow: visible;">
        </amp-video-iframe>
        <div style="right: 1px; position: fixed; bottom: 52px;" id="primis-video-amp">
          <amp-layout
            width="213"
            height="120"
            id="primis-dock-slot">
          </amp-layout>
        </div>
      `,
      }}
    />
  );
};
